import { useMessage } from 'shared/hooks/use-message'
import useService from 'Hooks/use-service'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getQuestionPreview } from 'Services/exams.service'

export const useQuestionPreview = () => {
    const params = useParams()
    const { questionVersionId, examVersionId, questionsetVersionId } = params
    const { trigger, isLoading, data, error } = useService(getQuestionPreview)
    const [messageApi] = useMessage()

    useEffect(() => {
        if (!data && questionVersionId && examVersionId && questionsetVersionId) {
            trigger({ questionVersionId, examVersionId, questionsetVersionId })
        }
    }, [data, examVersionId, questionVersionId, questionsetVersionId, trigger])

    useEffect(() => {
        if (error) {
            messageApi.error('Failed to load the question preview. Please try again')
            console.error('Failed to load the question preview. Please try again')
        }
    }, [error, messageApi])

    return { trigger, isLoading, data, error }
}
